<app-vvr-icon [full]="false" [dark]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Mal aanvragen</h1>
        </div>
        <div class="controls">
            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar overzicht"
                matTooltipPosition="below"
                routerLink="/{{Routenames.moldRequest}}">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
    <div class="row">
        @if (form()) {
            <div class="col-md-9">
                <form [formGroup]="form()">
                    <div class="row">
                        <mat-form-field appearance="fill" class="col-md-6">
                            <mat-label>Status</mat-label>
                            <mat-select [formControl]="fc.status_id" placeholder="Status">
                                @for (status of statusList; track status) {
                                    <mat-option [value]="status.id">
                                        {{status.name}}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="col-md-6">
                            <mat-label>Manager</mat-label>
                            <mat-select [formControl]="fc.manager_id" placeholder="Manager">
                                @for (manager of managerList; track manager) {
                                    <mat-option [value]="manager.id">
                                        {{manager.name}}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field appearance="fill" class="col-md-6">
                            <mat-label>Materiaal</mat-label>
                            <mat-select [formControl]="fc.material_id" placeholder="Materiaal">
                                @for (material of materialList(); track material) {
                                    <mat-option [value]="material.id">
                                        {{material.name}}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <ng-select
                            [closeOnSelect]="true"
                            [items]="decorations"
                            bindLabel="name"
                            bindValue="id"
                            class="col-md-6"
                            formControlName="decoration_id"
                            groupBy="decoration_group"
                            name="decoration_id"
                            placeholder="Figuratie">
                        </ng-select>
                    </div>
                    <div class="row">
                        <mat-form-field appearance="fill" class="col-md-12">
                            <mat-label>Opmerkingen</mat-label>
                            <textarea
                                [formControl]="fc.comment"
                                cdkAutosizeMinRows="4"
                                cdkTextareaAutosize
                                matInput
                                placeholder="Voeg hier eventuele notities en opmerkingen toe">
                            </textarea>
                        </mat-form-field>
                    </div>
                    @if (fc.status_id.value === 3) {
                        <div class="row mb-2">
                            <mat-form-field appearance="fill" class="col-md-12">
                                <mat-label>Reden van afkeuren</mat-label>
                                <textarea
                                    [formControl]="fc.reason"
                                    cdkAutosizeMinRows="4"
                                    cdkTextareaAutosize
                                    matInput
                                    placeholder="Voeg hier de reden van het afkeuren toe">
                                </textarea>
                                <mat-error>Dit veld is verplicht</mat-error>
                            </mat-form-field>
                        </div>
                    }
                </form>
                <div class="files">
                    @for (file of request.images; track file) {
                        <div class="file">
                            <div
                                (click)="openFile(file, request.images)"
                                [class.is-img]="['jpg', 'jpeg', 'png'].indexOf(file.ext) !== -1"
                                [style.background-image]="(file.file.substr(0,4) !== 'http' ? url : '') + file.file+'?access_token='+token|safeBgUrl">
                                <div class="icon"><i class="fas fa-file fa-3x"></i></div>
                                <div class="filename">
                                    {{file.name}}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
        <div class="col-md-3">
            @if (request?.status_log?.length) {
                <mat-list class="row">
                    <div class="pb-0" mat-subheader>Statuswijzigingen</div>
                    @for (log of request.status_log; track log) {
                        <mat-list-item>
                            <div mat-line>
                                {{log.status.name}}
                            </div>
                            <div mat-line>
                                {{log.user.name}} - {{log.created_at | date:'dd MMMM yyyy HH:mm'}}
                            </div>
                        </mat-list-item>
                    }
                </mat-list>
            }
        </div>
    </div>
    <div class="controls-bottom">
        @if (!isCordova && request?.status_id === 1) {
            <label
                #upload
                matTooltip="Upload bestand"
                matTooltipPosition="before">
                <input
                    (change)="uploadFile($event)" hidden multiple type="file">
                <div class="fab big">
                    @if (!uploading()) {
                        <i class="fas fa-upload"></i>
                    }
                    @if (uploading()) {
                        <i class="fas fa-circle-notch fa-spin"></i>
                    }
                </div>
            </label>
        }
        @if (isCordova && request?.status_id === 1) {
            <div
                (click)="takePicture()"
                class="fab big"
                id="btn-AddImage"
                matTooltip="Camera"
                matTooltipPosition="before">
                <i class="fas fa-camera"></i>
            </div>
        }
        @if (request?.status_id === 1 && request?.id) {
            <div
                (click)="delete()"
                class="fab big"
                matTooltip="Aanvraag intrekken"
                matTooltipPosition="before">
                <i class="fas fa-trash"></i>
            </div>
        }
        <div
            (click)="save()"
            [class.disabled]="saving()"
            class="fab big primary"
            id="btn-Save"
            matTooltip="Opslaan"
            matTooltipPosition="before">
            @if (!saving()) {
                <i class="fas fa-save"></i>
            }
            @if (saving()) {
                <i class="fas fa-circle-notch fa-spin"></i>
            }
        </div>
    </div>
</div>
